import React from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/hooks";
import {
  selectActiveConfiguration,
  selectConfiguration,
  tenantConfigurationState,
} from "../../redux/feature/settings/configurations-slice";
import { formatMessage, formatMessageWithParams } from "../../utils/helpers/LanguageHelper";
import { ChoiceGroup, IChoiceGroupOption, ITooltipHostStyles, TooltipHost } from "@fluentui/react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import FooterPanel from "../layout/FooterPanel";
import { ButtonVariants } from "../../styles/fluent/ButtonVariants";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { SETTINGS } from "../../utils/constants/navigation";
import { logout } from "../../common/login/LogoutDialog";
import { login } from "../../common/login/LoginDialog";
import LoadingManager from "../../common/loading/LoadingManager";

export interface ConfigurationsPaneProps {}

export const ChooseConfigPane: React.FunctionComponent<ConfigurationsPaneProps> = () => {
  const configurationState = useAppSelector(tenantConfigurationState);
  const activeConfiguration = useAppSelector(selectActiveConfiguration);
  const dispatch = useAppDispatch();
  const calloutProps = { gapSpace: 0 };
  const hostStyles: Partial<ITooltipHostStyles> = { root: { display: "inline-block" } };
  const choiceGroupDisabled =
    configurationState.documentTenantId !== "" && configurationState.documentTenantId !== undefined;

  const configOptions: IChoiceGroupOption[] = configurationState.configurations.map((value) => {
    return {
      key: value.name,
      text: value.name,
      ariaLabel: value.name,
      onRenderField: (props, render) => {
        return (
          <TooltipHost content={value.url} id={value.name} calloutProps={calloutProps} styles={hostStyles}>
            {render(props)}
          </TooltipHost>
        );
      },
    };
  });

  const docTenantConfiguration = configurationState.configurations.find(
    (config) => config.tenantId === configurationState.documentTenantId
  );

  let docTenantConfigurationNotPresent = false;
  if (choiceGroupDisabled && docTenantConfiguration === undefined) {
    docTenantConfigurationNotPresent = true;
    LoadingManager.removeAll();
  }

  function _onChange(_ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
    dispatch(selectConfiguration(option.key));
  }
  return (
    <div style={{ padding: "0.5rem" }}>
      <div
        style={{
          fontSize: "1rem",
          fontWeight: "500",
          lineHeight: "1.25rem",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: "var(--color-blue)",
        }}
      >
        {formatMessage("cof.access.accessess.selectconfiguration")}
      </div>
      <div
        style={{
          marginTop: "15px",
          fontWeight: "500",
          padding: "0.5rem 0 0",
          fontSize: "1rem",
        }}
      >
        {formatMessage("cof.access.accessess.activeconfigurations")}
      </div>
      <ChoiceGroup
        disabled={choiceGroupDisabled}
        style={{ width: "100%" }}
        onChange={_onChange}
        defaultSelectedKey={activeConfiguration ? activeConfiguration.name : ""}
        options={configOptions}
        className={"forceWidthFull"}
      />

      {docTenantConfigurationNotPresent && (
        <>
          <div style={{ marginLeft: "0.5rem", marginTop: "0.5rem" }}>
            {formatMessageWithParams("cof.access.message.nodcumenttenant", {
              documentTenantId: configurationState.documentTenantId,
            })}
          </div>
          <div style={{ marginLeft: "0.5rem", marginTop: "0.5rem" }}>
            {formatMessageWithParams("cof.access.message.nodcumenttenant.detail", {
              documentTenantId: configurationState.documentTenantId,
            })}
            .
          </div>
        </>
      )}
      <FooterPanel>
        <PrimaryButton
          id="configurations_button"
          text={formatMessage("cof.access.accessess.configurations")}
          style={{ float: "left", maxWidth: "calc(50% - 4px)", width: "100%" }}
          onClick={() => dispatch(navigate(SETTINGS))}
          className={ButtonVariants.white}
        />
        {activeConfiguration?.authData ? (
          <PrimaryButton //If logged in
            id="logout_button"
            className={ButtonVariants.primary}
            text={formatMessage("cof.access.accessess.logout")}
            onClick={() => logout(activeConfiguration.tenantId)}
            style={{ float: "right", maxWidth: "calc(50% - 4px)", width: "100%" }}
          />
        ) : (
          <PrimaryButton //if not logged in
            id="authenticate_button"
            className={ButtonVariants.primary}
            disabled={!activeConfiguration} //if no config available disable
            text={formatMessage("cof.access.accessess.authenticate")}
            onClick={() => login(activeConfiguration.tenantId)}
            style={{ float: "right", maxWidth: "calc(50% - 4px)", width: "100%" }}
          />
        )}
      </FooterPanel>
    </div>
  );
};
